import { BaseWebComponentTranslator } from '../../../framework/BaseWebComponentTranslator';
import { html } from 'lit';
import { riskManagementEntitiesRenderer, selectColumnRenderer } from '../../common/customRenderers';
import { ActionsColumnValues, DEVICES_CLASS, DEVICES_TYPES_ORDER, State } from '../../common/constants';
import { translateFn } from '../../../utils/translator.helper';
import { RiskManagementSideMenuEvents } from '../../sideMenus/common/common';

export function userTypeRenderer(rowData) {
  const userTypes = rowData?.item?.userType;
  if (!userTypes) {
    return '-';
  }

  const translator = BaseWebComponentTranslator.getInstance();
  return html`<span class="cell-label">
    ${userTypes.map(userType => translator.getRiskManagementUserType(userType)).join(', ')}
  </span>`;
}

export function departmentRenderer(rowData) {
  const department = rowData?.item?.department;
  if (!department) {
    return html`<span class="cell-label">${translateFn('Unknown')}</span>`;
  }

  return html`<span class="cell-label">${department}</span>`;
}

export function risksRenderer(rowData) {
  const devices = rowData?.item?.devices;

  const uniqueIndicators = new Set();

  devices?.map(device => {
    device.items?.map(item => {
      item.indicators?.map(indicator => {
        uniqueIndicators.add(indicator.indicatorId);
      });
    });
  });

  return html`<span class="cell-label">${uniqueIndicators.size.toString()}</span>`;
}

export function userDevicesRenderer(rowData) {
  const entities: any = [];
  const devices = rowData?.item?.devices;

  if (!devices) {
    return '-';
  }

  devices.map(device => {
    const entity: any = {
      type: device.type,
    };

    const ids: any = [];
    device.items?.map((item: any) => {
      if (item.endpointId) {
        ids.push(item.endpointId);
      }
    });
    entity.ids = ids;

    entities.push(entity);
  });

  return riskManagementEntitiesRenderer.call(
    this,
    rowData?.item,
    entities,
    DEVICES_TYPES_ORDER,
    DEVICES_CLASS,
    BaseWebComponentTranslator.getInstance().getDeviceTypes
  );
}

export function actionsColumnRenderer(rowData) {
  if (!rowData.item.company.specifics.features.iorUsable) {
    return selectColumnRenderer.call(this, rowData, []);
  }

  const options = [] as Array<any>;

  if (rowData.item.state === State.IGNORED) {
    options.push({
      title: translateFn('Restore ignored identity'),
      value: ActionsColumnValues.RESTORE,
      event: {
        name: RiskManagementSideMenuEvents.RESTORE_USERS,
        detail: {
          usersIds: [rowData.item._id],
          companyId: rowData.item.company._id,
        },
      },
    });
  } else {
    options.push({
      title: translateFn('Ignore identity'),
      value: ActionsColumnValues.IGNORE,
      event: {
        name: RiskManagementSideMenuEvents.IGNORE_USERS,
        detail: {
          usersIds: [rowData.item._id],
          companyId: rowData.item.company._id,
        },
      },
    });
  }

  return selectColumnRenderer.call(this, rowData, options);
}
